import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ToastController } from '@ionic/angular';
import { AuthService } from '../auth.service';
import { Router } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ErrorInterceptor implements HttpInterceptor {

  constructor(private toastController: ToastController, private authService: AuthService, private router: Router) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {

        /*let errorMessage = 'Bilinmeyen bir hata oluştu!';
        if (HttpErrorResponse.status === 401) {
          errorMessage = 'Yetkilendirme hatası. Lütfen tekrar giriş yapın.';
          await this.authService.logout();
          this.router.navigate(['/login']);
        } else if (HttpErrorResponse.status === 403) {
          errorMessage = 'Erişim engellendi!';
        } else if (HttpErrorResponse.status === 500) {
          errorMessage = 'Sunucu hatası!';
        }

        if ([401, 403].includes(err.status) && this.authenticationService.userValue) {
          // auto logout if 401 or 403 response returned from api
          //this.authenticationService.logout();
        }*/

        if ([401, 403].includes(err.status) && err.url?.includes('app.happyreport.store/api')) {
          this.authService.logout();
          this.router.navigate(['/login']);
        }

        let error = err.error ? err.error : err.statusText;
        error = error.message == "" ? err : error;

        console.error(err);
        return throwError(() => error);
      })
    );
  }
}
